import { useCallback, useEffect, useState } from "react";

const useLiveMatchPermissions = ({
  isReadOnly,
  match,
  isAuthenticated,
  userRole,
  currentUserId,
}) => {
  const canEditScore = useCallback(() => {
    if (!isAuthenticated || !match) return false;

    // Backend-computed permissions take priority (set when match is fetched with auth cookie)
    if (match.userPermissions) {
      return !!match.userPermissions.canStart;
    }

    // Fallback: admins always can edit
    if (userRole === "super_admin" || userRole === "platform_admin" ||
        userRole === "org_admin" || userRole === "league_admin") {
      return true;
    }

    // Fallback: match host
    const matchCreator = match.created_by || match.createdBy;
    if (matchCreator !== undefined && matchCreator !== null && matchCreator === currentUserId) {
      return true;
    }

    return false;
  }, [isAuthenticated, match, userRole, currentUserId]);

  const [isReadOnlyMode, setIsReadOnlyMode] = useState(true);

  useEffect(() => {
    const newReadOnlyMode = isReadOnly || !canEditScore();
    setIsReadOnlyMode(newReadOnlyMode);
  }, [isReadOnly, canEditScore]);

  return {
    isReadOnlyMode,
    canEditScore,
  };
};

export default useLiveMatchPermissions;
